import _objectWithoutProperties from "@babel/runtime/helpers/objectWithoutProperties";
import React from 'react';
import { List } from './List';
import { StyledMenu } from './Menu.styled';
export function Menu(_ref) {
  var attachRight = _ref.attachRight,
    listProps = _objectWithoutProperties(_ref, ["attachRight"]);
  return /*#__PURE__*/React.createElement(StyledMenu, {
    attachRight: attachRight
  }, /*#__PURE__*/React.createElement(List, listProps));
}